import { makeStyles } from '@mui/styles';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import React from 'react';

import { getTransactionTypeString } from 'Lib/transactionTypeHelper';

interface TransactionTypeConversion {
    value: any;
    data: TransactionHistoryRecord;
    isAdmin: boolean;
}

const muiStyles = makeStyles(() => ({ cellStyle: { textTransform: 'capitalize' }}));

export const TransactionTypeConversion = ({ value, data }: TransactionTypeConversion) => {
    const styles = muiStyles();
    const tranType = getTransactionTypeString(data);

    return (
        <span className={styles.cellStyle}>{tranType}</span>
    );
};